import { CodePenCard } from "components/cards/CodePenCard";
import { EmptyShowcase } from "components/showcases/EmptyShowcase";
import { useCodePens } from "hooks/useCodePens";
import { useState } from "react";
import './CodePensShowcase.scss';

export const CodePensShowcase = () => {
    const { codePens, loading, error } = useCodePens()
    const [codepenSelected, setCodepenSelected] = useState(null);
    if (loading) {
        return <p>Loading codepens...</p>
    }
    if (error !== null) {
        return <p>There was an error meanwhile we are loading the codepens.</p>
    }

    const handlerCodepenSelected = (codepen) => setCodepenSelected(codepen);

    if (loading) {
        return <p>Loading codepens...</p>
    }
    if (error !== null) {
        return <p>There was an error meanwhile we are loading the codepens.</p>
    }

    return (
        <div className="codepensshowcase">
            <div className="codepensshowcase__panel">
                <ul className="codepensshowcase__list">
                    {!loading && codePens.length === 0
                        && (
                            <p>I'm so sorry. There aren't UI Components to show. Please, try again.</p>
                        )}
                    {
                        codePens.map(codepen => {
                            return (
                                <li className="codepensshowcase__item" key={codepen.id}>
                                    {
                                        codepenSelected === null
                                            ? (
                                                <button
                                                    className="codepensshowcase__button codepensshowcase__button--outline"
                                                    onClick={() => {
                                                        handlerCodepenSelected(codepen)
                                                    }}
                                                >
                                                    {codepen.title}
                                                </button>
                                            )
                                            : (
                                                codepenSelected.id === codepen.id
                                                    ? (
                                                        <button
                                                            className="codepensshowcase__button codepensshowcase__button--selected"
                                                            onClick={() => {
                                                                handlerCodepenSelected(codepen)
                                                            }}
                                                        >
                                                            {codepen.title}
                                                        </button>
                                                    )
                                                    : (
                                                        <button
                                                            className="codepensshowcase__button codepensshowcase__button--outline"
                                                            onClick={() => {
                                                                handlerCodepenSelected(codepen)
                                                            }}
                                                        >
                                                            {codepen.title}
                                                        </button>
                                                    )
                                            )
                                    }
                                </li>
                            )
                        })
                    }
                </ul>
            </div>
            <div className="codepensshowcase__demo">
                {codepenSelected !== null && <CodePenCard codepen={codepenSelected} />}
                {codepenSelected === null && <EmptyShowcase />}
            </div>
        </div>
    )
}